export const CTA_TYPE = Object.freeze({
    BUTTON: 'button',
    LINK: 'link'
});
